import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import CustomTextInput from "./CustomTextInput";
import CustomAutoComplete from "./CustomAutoComplete";
import api from "../api";

const ModalWashes = ({
  title,
  isOpen,
  onClose,
  onClick,
  btnText,
  onAddDriver,
  onAddCar,
}) => {
  const [error, setError] = useState(null);
  const [washType, setWashType] = useState("");
  const [drivers, setDrivers] = useState("");
  const [driver, setDriver] = useState("");
  const [cars, setCars] = useState("");
  const [car, setCar] = useState("");
  const [date, setDate] = useState("");

  const [fieldErrors, setFieldErrors] = useState({});

  const washesTypeOptions = [
    { value: 1, label: "Aspirado" },
    { value: 2, label: "Ducha" },
    { value: 3, label: "Completo" },
  ];

  useEffect(() => {
    async function fetchDrivers() {
      try {
        const response = await api.drivers.getMulti();

        setDrivers(response);
      } catch (error) {
        console.error("Error fetching drivers:", error);
      }
    }
    async function fetchVehicles() {
      try {
        const response = await api.vehicles.getMulti();

        setCars(response);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      }
    }
    fetchDrivers();
    fetchVehicles();
  }, []);

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setFieldErrors({});

    const data = {
      washType: washType ? +washType : null,
      driver: driver,
      vehicle: car,
      date: date,
    };

    try {
      await api.washes.create(data);
      onClick();
      onClose(); // Cierra el modal después de guardar
      // Reinicia los valores del formulario
      setWashType("");
      setDriver("");
      setCar("");
      setDate("");
    } catch (error) {
      if (error.message) {
        setFieldErrors(error.message); // Ajustar esto según la estructura del error
      } else {
        setError("Ocurrió un error al enviar los datos.");
      }
    }
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        {/* Fondo oscuro */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-6">
            {/* Animación del panel */}
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4"
              enterTo="opacity-100 translate-y-0"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-4"
            >
              <Dialog.Panel className="relative bg-white rounded-lg shadow-lg md:w-[480px] p-10">
                {/* Título */}
                <Dialog.Title
                  as="h2"
                  className="poppins-medium text-[18px] text-center text-[#1F384C] tracking-wide"
                >
                  {title}
                </Dialog.Title>

                <div className="mt-7 space-y-6 mb-[62px]">
                  <div>
                    <CustomTextInput
                      options={washesTypeOptions}
                      placeholder="Tipo de lavado"
                      type="select"
                      value={washType}
                      onChange={(e) => setWashType(e.target.value)}
                    />
                    {fieldErrors.washType && (
                      <p className="text-red-600 text-sm">
                        {fieldErrors.washType[0]}
                      </p>
                    )}
                  </div>
                  <div>
                    <CustomAutoComplete
                      placeholder="Asigna al conductor"
                      value={driver}
                      onChange={setDriver}
                      options={drivers}
                      labelKey="name"
                      valueKey="id"
                      onAddNew={onAddDriver}
                    />
                    {fieldErrors.driver && (
                      <p className="text-red-600 text-sm">
                        {fieldErrors.driver[0]}
                      </p>
                    )}
                  </div>
                  <div>
                    <CustomAutoComplete
                      placeholder="Selecciona el vehículo"
                      type="select"
                      value={car}
                      onChange={setCar}
                      options={cars}
                      labelKey="name"
                      valueKey="id"
                      onAddNew={onAddCar}
                    />
                    {fieldErrors.vehicle && (
                      <p className="text-red-600 text-sm">
                        {fieldErrors.vehicle[0]}
                      </p>
                    )}
                  </div>
                  <div>
                    <CustomTextInput
                      placeholder="Fecha"
                      type="date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      isRequired
                    />
                    {fieldErrors.date && (
                      <p className="text-red-600 text-sm">
                        {fieldErrors.date[0]}
                      </p>
                    )}
                  </div>
                </div>

                {error && <p className="text-red-600 mb-4">{error}</p>}

                <button
                  onClick={handleFormSubmit}
                  className={`bg-[#BE202F] w-full text-white text-xs py-4 px-4 rounded-2xl tracking-wider poppins-medium focus:outline-none`}
                >
                  {btnText}
                </button>

                <button
                  onClick={onClose}
                  className="absolute top-4 right-4 text-[#000000] hover:text-gray-600 focus:outline-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    className="w-8 h-8"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalWashes;
